import { useActions, useAppSelector } from '@/hooks'
import { stateDeviceSelector } from '@/modules/aqua-device-module/store/stateSlice'
import cn from '@/utils/cn'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { Box } from '@mui/material'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useGetUnitsListMutation } from '@/modules/devices-list/services/newUnitsListService'

const s = cn('device-module-calendar')
const Calendar = () => {
  // const { fromDate, toDate, selectedTab, fromDateEvents } =
  //   useAppSelector(stateDeviceSelector)
  const [fromDate, setFromDate] = useState<dayjs.Dayjs>(
    dayjs(new Date().setHours(0, 0, 0, 0)).subtract(1, 'year')
  )
  const [toDate, setToDate] = useState<dayjs.Dayjs>(
    dayjs(new Date().setHours(0, 0, 0, 0))
  )
  const [getUnitsService, { isLoading: isLoadingSearch }] =
    useGetUnitsListMutation()
  const fetchUnits = async () => {
    try {
      // const searchParams = {
      //     value: searchValue.trim().length ? searchValue : '',
      //     deviceTypeFilter: deviceTypeFilter,
      //     page: currentPage,
      //     userId: Number(id),
      // }
      // const response = await getUnitsService(searchParams).unwrap()
      // if (response.success) {
      //     setSelectAll(response.data.every((unit) => unit.selected))
      //     setUnits(response.data)
      //     setCurrentPage(response.page || 1)
      //     setTotalPages(response.pages || 1)
      //     setTotalCount(response.count ?? 0)
      // }
      // if (!searchValue.trim().length) {
      //     updateSearchValue('')
      // }
    } catch (error) {
      console.error(error)
    }
  }
  // const { setToDate, setFromDate, setFromDateEvents } = useActions()

  useEffect(() => {
    console.log(fromDate, toDate)
    fetchUnits()
  }, [fromDate, toDate])

  return (
    <Box
      display='flex'
      alignItems='center'
      gap={{ xss: 0, md: 1 }}
      className={s()}
      sx={{
        width: 315,
        zIndex: 9999999,
      }}
    >
      <DatePicker.RangePicker
        showTime
        allowClear={false}
        disabled={isLoadingSearch}
        variant={'borderless'}
        style={{ width: 315, zIndex: 9999999 }}
        value={[fromDate, toDate]}
        format='DD.MM.YYYY HH:mm'
        suffixIcon={
          <CalendarMonthIcon
            htmlColor={'dark-gray'}
            fontSize='medium'
          />
        }
        onChange={(e) => {
          setFromDate(dayjs(e ? e[0] : fromDate))
          setToDate(dayjs(e ? e[1] : toDate))
        }}
        // disabledDate={(e) => {
        //   return selectedTab === 1
        //     ? false
        //     : e.isBefore(dayjs().subtract(2, 'month'))
        // }}
      />
    </Box>
  )
}

export default Calendar
